import React from 'react';
import { useStyles } from './ProcessStatistics.styles';
import { getProcessLabel } from '../../../utils/assessmentSessionProcess';
import ProcessChart, { ProcessChartValue } from './ProcessChart.component';
import { ExamTaskGroupSolutionScoreStatistic } from '../../../services/scoringModel/scoringModel.types';
import { kkColor, pzwoColor, totalColor, ZWOreadyColor } from './ProcessChart.styles';

const ProcessStatistics: React.FC<ExamTaskGroupSolutionScoreStatistic> = ({
  processTypeId,
  kkProgress,
  pzwoProgress,
  zwoReady,
  total,
}) => {
  const classes = useStyles();
  const processLabel = getProcessLabel(processTypeId);

  const styledKKProgress = {
    value: kkProgress,
    color: kkColor,
  } as ProcessChartValue;

  const styledPwoProgress = {
    value: pzwoProgress,
    color: pzwoColor,
  } as ProcessChartValue;

  const styledZwoReady = {
    value: zwoReady,
    color: ZWOreadyColor,
  } as ProcessChartValue;

  const styledTotal = {
    value: total,
    color: totalColor,
  } as ProcessChartValue;

  return (
    <div className={classes.processBox}>
      <div className={classes.title}>{processLabel.label}</div>

      <div className={classes.chartRow}>
        <div className={classes.chartLabel}>RGZ</div>
        <div className={classes.chart}>
          <ProcessChart
            kkProgress={styledKKProgress}
            pzwoProgress={styledPwoProgress}
            zwoReady={styledZwoReady}
            total={styledTotal}
          />
        </div>
      </div>
      <div className={classes.legendRow}>
        <div className={classes.legendLabel}>
          Przygotowane
          <br /> przez ZWO
        </div>
        <div className={classes.zwoReadyData}>
          <div className={classes.legendValue}>{zwoReady}</div>
        </div>

        <div className={classes.legendLabel}>PZWO</div>
        <div className={classes.pzwoData}>
          <div className={classes.legendValue}>{pzwoProgress}</div>
        </div>

        <div className={classes.legendLabel}>KK</div>
        <div className={classes.kkData}>
          <div className={classes.legendValue}>{kkProgress}</div>
        </div>

        <div className={classes.legendLabel}>Wymagane</div>
        <div className={classes.totalData}>
          <div className={classes.legendValue}>{total}</div>
        </div>
      </div>
    </div>
  );
};

export default ProcessStatistics;
